// extracted by mini-css-extract-plugin
export default {"label":"utils_label__XXHdL","label-italic":"utils_label-italic__2q6q+","input-wrapper":"utils_input-wrapper__Ot2D9","error":"utils_error__fA+tU"};